module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAAXUlEQVQ4T2NkoBJgpJI5DHCD/v//38DAwGBPosGJjIyMD0B6kA0qYGBgCCDBoA8MDAwFGAaRYABWpdQPI6q5iJqBDYo1BxJdljDCAhuUIP1JCCNQgizElrKHWWADAF0uIBEUFBrRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/mobilemenu.png
// module id = ebS5
// module chunks = 1